import React from 'react';
import LayoutMobileFixedHeight from '../../../../../Common/Mobile/Layout/FixedHeight/LayoutMobileFixedHeight';
import LayoutMobile from '../../../../../Common/Mobile/Layout/LayoutMobile';
import { useTranslation } from 'react-i18next';
import styles from './SignUpGreatWorkStep.module.scss';
import image from '../../../../../../assets/images/great_work.png';
import GoToQuestionnaireButton from './Fetaures/GoToQuestionnaireButton';

function SignUpGreatWorkStepMobile() {
  const { t } = useTranslation();
  return (
    <LayoutMobileFixedHeight>
      <LayoutMobile>
        <div className={styles.container}>
          <div className={styles.title}>
            <span>{t('signup.greatwork.title.great')}</span>
            <span>{t('signup.greatwork.title.now')}</span>
          </div>
          <div style={{ backgroundImage: `url(${image})` }} className={styles.image}/>
          <GoToQuestionnaireButton buttonLabel={t('signup.greatwork.button.mobile')}/>
        </div>
      </LayoutMobile>
    </LayoutMobileFixedHeight>
  )
}

export default SignUpGreatWorkStepMobile;